import React, { memo } from 'react'

function FormQuickBook(props) {
    const { formik } = props
    return (
        <React.Fragment>
            <div className="quickbook-settings-content">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Product Export Settings</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        Select how products should be named in QuickBooks.Products attached to orders  will be created or matched in QuickBooks based on name.If a product is not found, a new one will be created.
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className="media-body st-form-input-container align-left">
                            <span className="d-flex st-fw-600 align-items-baseline">
                                <input type="radio" className="me-2" id="title"
                                    {...formik.getFieldProps('productExport')}
                                    value="TITLE"
                                    name={"productExport"}
                                    checked={formik.values.productExport === "TITLE"}
                                    onChange={e => {
                                        formik.setFieldValue("productExport", e.target.value)
                                    }}
                                />{`Title and varient `}
                            </span>
                            <span className="d-flex st-fw-600 align-items-baseline">
                                <input type="radio" className="me-2" id="sku"
                                    {...formik.getFieldProps('productExport')}
                                    value="SKU"
                                    name={"productExport"}
                                    checked={formik.values.productExport === "SKU"}
                                    onChange={e => {
                                        formik.setFieldValue("productExport", e.target.value)
                                    }}
                                />{`SKU matched against the QuickBooks item NAME field.`}</span>
                        </div>

                    </div>
                </div>
            </div>
            <div className="quickbook-settings-content">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Customer Export Settings</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        Customer Data attached to orders will be exported to QuickBooks Online.
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                            <div className="media-body st-form-input-container align-left">

                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="radio" className="me-2" id="active"
                                        {...formik.getFieldProps('customerExport')}
                                        value={1}
                                        name="customerExport"
                                        checked={formik.values.customerExport === 1}
                                        onChange={e => {
                                            formik.setFieldValue("customerExport", 1)
                                        }}
                                    /> {` Export customers to QuickBooks Online `}
                                </span>
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="radio" className="me-2" id="active"
                                        {...formik.getFieldProps('customerExport')}
                                        value={0}
                                        name="customerExport"
                                        checked={formik.values.customerExport !== 1}
                                        onChange={e => {
                                            formik.setFieldValue("customerExport", 0)
                                        }}
                                    />{` Do not export customersto QuickBooks Online. Instead, a single Shopify Customer-Quick Bookkeeping & Accounting: QuickBooks Solution Provider customer will be used for all others. `}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quickbook-settings-content">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Export Settings</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        You can schedule automatic daily exports and configure notification emails
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                            <div className="media-body st-form-input-container align-left">
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="checkbox" className="me-2" id="automatic"
                                        {...formik.getFieldProps('exportSettings.automatic')}
                                        checked={formik.values.exportSettings.automatic}
                                        onChange={e => {
                                            formik.setFieldValue("exportSettings.automatic", e.target.checked)
                                        }}
                                    /> {` Automatic export daily (after midnight ) `}
                                </span>
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="checkbox" className="me-2" id="notifications"
                                        {...formik.getFieldProps('exportSettings.notifications')}
                                        checked={formik.values.exportSettings.notifications}
                                        onChange={e => {
                                            formik.setFieldValue("exportSettings.notifications", e.target.checked)
                                        }}
                                    />{` Receive export notifications by email `}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quickbook-settings-content ">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Create Sales</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        You can schedule automatic daily exports and configure notification emails
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                            <div className="media-body st-form-input-container align-left">
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="checkbox" className="me-2" id="createSale"
                                        {...formik.getFieldProps('createSale')}
                                        value="1"
                                        checked={formik.values.createSale}
                                        onChange={e => {
                                            formik.setFieldValue("createSale", e.target.checked)
                                        }}
                                    /> {`When an Order is created in Shopify, create a Sale in QuickBooks Online`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quickbook-settings-content ">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Create Deposit</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        You can schedule automatic daily exports and configure notification emails
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                            <div className="media-body st-form-input-container align-left">
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="checkbox" className="me-2" id="createDeposit"
                                        {...formik.getFieldProps('createDeposit')}
                                        value="1"
                                        checked={formik.values.createDeposit}
                                        onChange={e => {
                                            formik.setFieldValue("createDeposit", e.target.checked)
                                        }}
                                    /> {`When a Payout is paid by Shopify, create a Deposit in QuickBooks Online`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quickbook-settings-content ">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Create Item</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        You can schedule automatic daily exports and configure notification emails
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                            <div className="media-body st-form-input-container align-left">
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="checkbox" className="me-2" id="createItem"
                                        {...formik.getFieldProps('createItem')}
                                        value="1"
                                        checked={formik.values.createItem}
                                        onChange={e => {
                                            formik.setFieldValue("createItem", e.target.checked)
                                        }}
                                    /> {`When a Product is created in Shopify, create a new Item in QuickBooks Online`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quickbook-settings-content border-bottom">
                <div className="content-right">
                    <div className="d-flex align-items-center " >
                        <span className="app-heading text-capitalize me-3">Update Stock</span>
                    </div>
                    <p className="app-integrations-desc pad-12-T">
                        You can schedule automatic daily exports and configure notification emails
                    </p>

                </div>
                <div className="content-left">
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center`}>
                            <div className="media-body st-form-input-container align-left">
                                <span className="d-flex st-fw-600 align-items-baseline">
                                    <input type="checkbox" className="me-2" id="updateStock"
                                        {...formik.getFieldProps('updateStock')}
                                        value="1"
                                        checked={formik.values.updateStock}
                                        onChange={e => {
                                            formik.setFieldValue("updateStock", e.target.checked)
                                        }}
                                    /> {`When Stock Levels are updated in QuickBooks Online, update Stock Levels in Shopify`}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(FormQuickBook)